import React from 'react';
import './style.css';

class Aba extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        ano: new Date
    }
  }
  render(){
    return <div>
        <p>
        Eu sou Red. Eu tenho { this.state.ano.getFullYear() - 2003} anos. Eu moro no Brasil, Santa Catarina. E eu gosto de fazer mapas e vídeos. Meus jogos favoritos são Half-life 2 e Crysis.
        </p>
    </div>
  };
}

export default Aba;